import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {component_tool} from '../../../../tool'
import {WizDataAuthSelect} from '@/containers/common'

let {WizButton, WizSpin, WizAntdForm, WizRow, WizCol} = component_tool

class SurveyAuthSelect extends Component {

  componentName = 'surveyAuthSelect';

  constructor(props) {
    super(props);
    this.state = {
      surveyStatus: 0
    }
  }

  _onReset = () => {
    this.props.form.resetFields()
  }

  _prev = (prevFunc) => {
    if (prevFunc) {
      this.props.prevFunc && this.props.prevFunc()
    }
  }
  _surveyOnRelease(flag) {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let {submit} = this.props
        submit && submit(values, flag)
      }
    });
  }

  render() {
    let {form, loading, initialValue,prevFunc} = this.props
    return (
      <WizSpin tip={'加载中'} spinning={loading}>
        <WizAntdForm>
          {
            form.getFieldDecorator('dataAuth', {initialValue:Object.assign({}, initialValue)})(
              <WizDataAuthSelect/>
            )
          }
          <WizAntdForm.Item wrapperCol={{span: 12, offset: 6}}>
            <WizRow className="form-btns row-item">
              <WizCol span={24} style={{textAlign: 'center'}}>
                <WizButton title="上一步" onClick={e => this._prev(prevFunc)}>上一步</WizButton>
                <WizButton type="primary" htmlType="submit" onClick={e => this._surveyOnRelease(true)}>
                  保存并发布
                </WizButton>
                <WizButton htmlType="submit" onClick={e => this._surveyOnRelease(false)}>
                  保存并返回
                </WizButton>
                <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton>
              </WizCol>
            </WizRow>
          </WizAntdForm.Item>
        </WizAntdForm>
      </WizSpin>
    )
  }
}

export default WizAntdForm.create()(SurveyAuthSelect);

/**
 * 默认值
 */
SurveyAuthSelect.defaultProps = {
  title: '数据权限选择',
  loading: false
}
/**
 * props入参校验
 */
SurveyAuthSelect.propTypes = {
  submit: PropTypes.fun,//提交的回调方法
  loading: PropTypes.bool
}
